import React from 'react';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/style.css';

import RegistryTable from '../shared/RegistryTable_RT.jsx';
import RegistryMap from '../shared/RegistryMap.jsx';
import ConfirmActionModal from '../shared/ConfirmActionModal.jsx';
import SearchBlock from '../shared/SearchBlock';

import * as api from '../../api/api';
import * as utils from '../../utils';

class DisplayPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displays: [],
      selectedObjectId: 0,
      isUserAdmin: api.isUserAdmin(),
      isMapShow: true,
    };

    this.processGetDisplaysPromise = this.processGetDisplaysPromise.bind(this);

    this.handleAddAction = this.handleAddAction.bind(this);
    this.handleEditAction = this.handleEditAction.bind(this);
    this.handleConfirmDeleteAction = this.handleConfirmDeleteAction.bind(this);

    this.handleRowClick = this.handleRowClick.bind(this);
    this.updateMarkers = this.updateMarkers.bind(this);

    // this.handleSearchButtonClick = this.handleSearchButtonClick.bind(this);
    this.handleResetSearchClick = this.handleResetSearchClick.bind(this);

    this.tableColumns = [
      {
        Header: '_id',
        accessor: 'id',
      },
      {
        Header: '#',
        accessor: 'number',
      },
      // {
      //     Header: 'Название',
      //     accessor: 'name',
      // },
      {
        Header: 'ID',
        accessor: 'id',
      },
      {
        Header: 'Описание',
        accessor: 'description',
      },
      {
        Header: 'Расположение',
        accessor: 'checkpointName',
      },
      {
        Header: 'Включено?',
        accessor: 'isEnabled',
      },
    ];

    this.mapMarkers = [];

    this.props.updateLoader({
      loaded: false,
      message: '',
    });
  }

  componentDidMount() {
    this.processGetDisplaysPromise(api.getDisplays());

    // api.getDisplays().then(
    //     (response) => {

    //         this.mapMarkers = response.data.data.map((item, i) => {
    //             return {
    //                 id: item.id,
    //                 title: item.name,
    //                 coordinates: [item.latitude, item.longitude]
    //             }
    //         });

    //         this.setState({
    //             displays: response.data.data.map((item, i) => {
    //                 return {
    //                     id: item.id,
    //                     number: i + 1,
    //                     name: item.name,
    //                     description: item.description,
    //                     latitude: utils.formatDouble(item.latitude),
    //                     longitude: utils.formatDouble(item.longitude),
    //                     checkpointName: item.checkpointName,
    //                     isEnabled: item.isEnabled
    //                 }
    //             })
    //         });

    //         this.props.updateLoader({
    //             loaded: true,
    //             message: ""
    //         });
    //     },
    //     (error) => {
    //         this.props.updateLoader({
    //             loaded: true,
    //             message: "Ошибка при получении данных: " + error
    //         });
    //     }
    // );
  }

  updateMarkers(start, end) {
    this.setState({
      mapMarkers: this.mapMarkers.slice(start, end),
      markersUpdateInd: start,
      selectedObjectId: 0,
    });
  }

  handleRowClick(displayId) {
    this.setState({
      selectedObjectId: displayId,
      markersUpdateInd: displayId,
    });
  }

  handleAddAction() {
    this.setState({
      redirectUrl: '/displays/0/details?return_url=/displays',
    });
  }

  handleEditAction() {
    this.setState({
      redirectUrl:
        '/displays/' +
        this.state.selectedObjectId +
        '/details?return_url=/displays',
    });
  }

  handleConfirmDeleteAction() {
    this.props.updateLoader({
      loaded: false,
      message: '',
    });

    api.makeRequest(api.removeDisplay(this.state.selectedObjectId)).then(
      (response) => {
        for (let i = 0; i < this.state.displays.length; i++) {
          if (this.state.selectedObjectId === this.state.displays[i].id) {
            let copy = this.state.displays.slice();
            copy.splice(i, 1);

            this.setState({
              displays: copy,
            });
          }
        }

        this.props.updateLoader({
          loaded: true,
          message: '',
        });
      },
      (error) => {
        this.props.updateLoader({
          loaded: true,
          message: 'Ошибка при выполнении действия: ' + error,
        });
      },
    );
  }

  processGetDisplaysPromise(promise) {
    this.props.updateLoader({
      loaded: false,
      message: '',
    });

    api.makeRequest(promise).then(
      (response) => {
        if (this.mapMarkers.length === 0) {
          this.mapMarkers = response.data.data.map((item, i) => {
            return {
              id: item.id,
              title: item.checkpoint.name,
              coordinates: [
                item.checkpoint.latitude,
                item.checkpoint.longitude,
              ],
            };
          });
        }

        this.setState({
          displays: response.data.data.map((item, i) => {
            return {
              id: item.id,
              number: i + 1,
              name: '',
              description: item.description,
              // latitude: utils.formatDouble(item.latitude),
              // longitude: utils.formatDouble(item.longitude),
              checkpointName: item.checkpoint.name,
              isEnabled: item.isEnabled ? 'Да' : 'Нет',
            };
          }),
        });

        this.props.updateLoader({
          loaded: true,
          message: '',
        });
      },
      (error) => {
        this.props.updateLoader({
          loaded: true,
          message: 'Ошибка при получении данных: ' + error,
        });
      },
    );
  }

  // handleSearchButtonClick(searchValue) {
  //     this.processGetDisplaysPromise(api.searchDisplays(searchValue));
  // }

  handleResetSearchClick() {
    this.processGetDisplaysPromise(api.getDisplays());
  }

  render() {
    if (this.state.redirectUrl) {
      return <Redirect to={this.state.redirectUrl} />;
    }

    return (
      <div className="d-flex justify-content-between">
        <div className="flex-grow-1">
          <SearchBlock
            placeholder="Введите часть названия или описания..."
            handleSearchButtonClick={this.handleSearchButtonClick}
            onResetSearchClick={this.handleResetSearchClick}
          />
          <div className="mt-4">
            <RegistryTable
              columns={this.tableColumns}
              data={this.state.displays}
              showActions={this.state.isUserAdmin}
              onRowClick={this.handleRowClick}
              onAddAction={this.handleAddAction}
              onEditAction={this.handleEditAction}
              onPageChange={(start, end) => this.updateMarkers(start, end)}
              customBtnGroup={
                utils.getIsViewportEqual('xs', 'sm') ? null : (
                  <div className="btn-group ml-3">
                    <button
                      className="btn btn-secondary"
                      title="Показать/скрыть карту"
                      onClick={() =>
                        this.setState({ isMapShow: !this.state.isMapShow })
                      }
                    >
                      <FontAwesomeIcon icon="map" size="sm" color="#fff" />
                    </button>
                  </div>
                )
              }
            />
          </div>
        </div>

        {/* <div className="ml-4 d-none d-md-inline d-lg-inline d-xl-inline"> */}
        <div
          className={
            this.state.isMapShow && !utils.getIsViewportEqual('xs', 'sm')
              ? 'ml-4'
              : 'd-none'
          }
        >
          <RegistryMap
            mapSettings={{ center: [57.15, 65.53], zoom: 9 }}
            markers={this.state.mapMarkers}
            updateInd={this.state.markersUpdateInd}
            selectedId={this.state.selectedObjectId}
          />
        </div>
        <ConfirmActionModal onConfirm={this.handleConfirmDeleteAction} />
      </div>
    );
  }
}

export default DisplayPage;
